import {Component, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {DialogComponent} from "@syncfusion/ej2-angular-popups";
import {ArticleDataModel} from "../../../../core/services/portal-data/article-data.model";
import {UtilService} from "../../../../core/services/util/util.service";
import {PortalService} from "../../../../core/services/portal/portal.service";
import {ListViewComponent} from "@syncfusion/ej2-angular-lists";
import {SelectEventArgs} from "@syncfusion/ej2-lists/src/list-view/list-view";
import {ButtonPropsModel} from "@syncfusion/ej2-popups/src/dialog/dialog-model";
import {$translate} from "../../../../core/services/internationalization/localize.service";

@Component({
  selector: 'sb-portal-announcements, sb-dynamic-portal-announcements',
  templateUrl: './portal-announcements.component.html',
  styleUrls: ['./portal-announcements.component.scss'],
})
export class PortalAnnouncementsComponent implements OnInit {

  @ViewChild('ejListView', {static: false}) ejListView: ListViewComponent;

  @ViewChild('ejDialog', {static: false}) ejDialog: DialogComponent;

  // Allow the dynamic portal component to trigger a refresh
  @Input()
  set refresh(_: boolean) {
    this._refresh = !this._refresh;
    this.loadMore();
  };
  get refresh(): boolean {
    return this._refresh;
  }
  _refresh = false;

  NO_RESULTS_ID = "-1";

  articles: ArticleDataModel[]  = [];

  noResultsArticle: any = {
    type: "announcement",
    id: this.NO_RESULTS_ID,
    title: $translate("ng.component.portal-announcements.no-announcements")`There are no current announcements`,
  };

  modalArticle: ArticleDataModel = null;

  buttons: ButtonPropsModel[] = [
    {
      'click': () => { this.ejDialog.hide() },
      buttonModel: {
        content: $translate("common.button.close")`Close`,
        isPrimary: true,
      }
    },
  ];

  constructor(private utilService: UtilService,
              private portalService: PortalService) {
  }

  ngOnInit(): void {
    this.loadMore();
  }

  async loadMore() {
    const announcements = await this.portalService.getPortalDataService().getAnnouncements();
    this.articles = announcements.length > 0 ? announcements : [this.noResultsArticle];
  }

  openModal(item: ArticleDataModel) {
    this.modalArticle = item;
    this.utilService.tickThen(() => {
      this.ejDialog.show();
    });
  }

  onClose(_: any) {
    this.ejDialog.hide();
    this.modalArticle = null;
  }

  onSelect(e: SelectEventArgs) {
    e.cancel = true;
    e.item.classList.remove('e-active');
    if ((e.data as any).id != this.NO_RESULTS_ID) {
      this.openModal(e.data as unknown as ArticleDataModel);
    }
  }
}
